import { User }          from '@app/modules/user/models/user.model';
import { APP_CONFIG }    from '@appConfig/_app-config_master';
import {
	createFeatureSelector,
	createSelector,
	MemoizedSelector
}                        from '@ngrx/store';
import { IManageTenant }     from '@shared/content-sections/manage-tenant/manage-tenant.model';
import { ICurrentUserState } from './state';

const getError = ( state: ICurrentUserState ): any => state ? state.error : null;
const getIsLoading = ( state: ICurrentUserState ): boolean => state ? state.isLoading : false;
const getIsAuthenticated = ( state: ICurrentUserState ): boolean => state ? state.isAuthenticated : false;
const getProfile = ( state: ICurrentUserState ): object => state.profile;
const getRoles = ( state: ICurrentUserState ): string[] => state.roles;
const getCurrentUserId = ( state: ICurrentUserState ): string => state.currentUserId;
const getCurrentUser = ( state: ICurrentUserState ): User => state.user;
const getManageTenant = ( state: ICurrentUserState ): IManageTenant => state.manageTenant;


// State Selector
export const getState: MemoizedSelector<object, ICurrentUserState> = createFeatureSelector<ICurrentUserState>( APP_CONFIG.currentUser.store.id );

// Property Selectors
export const error: MemoizedSelector<object, any> = createSelector( getState, getError );
export const isLoading: MemoizedSelector<object, boolean> = createSelector( getState, getIsLoading );
export const isAuthenticated: MemoizedSelector<object, any> = createSelector( getState, getIsAuthenticated );
export const profile: MemoizedSelector<object, any> = createSelector( getState, getProfile );
export const roles: MemoizedSelector<object, any> = createSelector( getState, getRoles );
export const currentUserId: MemoizedSelector<object, string> = createSelector( getState, getCurrentUserId );
export const currentUser: MemoizedSelector<object, User> = createSelector( getState, getCurrentUser );
export const manageTenant: MemoizedSelector<object, IManageTenant> = createSelector( getState, getManageTenant );
